import { render } from "./DisclosureDetails.vue?vue&type=template&id=d8931bb8"
import script from "./DisclosureDetails.vue?vue&type=script&lang=js"
export * from "./DisclosureDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__